import React, { useContext, useState, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { colorBackgroundBody } from '@/utils/palette';
import { paddingLeft } from '@/utils/directions';
import CryptoJS from 'crypto-js';
import Layout from '../../../Layout/index';
import Meal from '../../../Agent/Meal';
import Users from '../../../Agent/UserManager/Users/Index';
import Manager from '../../../Agent/UserManager/UserManagement/Manager';
import Dashboard from '../../../Agent/Dashboard/Dashboard';
import Booking from '../../../Agent/Booking';
import Account from '../../../Agent/Account/Index';
import Trip from '../../../Agent/Trips/Index';
import { AuthContext } from '../../../../context/AuthContext';
import PendingTable from '../../../Agent/PaymentTab/component/Pending';
import ApprovedTable from '../../../Agent/PaymentTab/component/Approved';
import RejectTable from '../../../Agent/PaymentTab/component/Reject';
import { PermissionContext } from '../../../../context/PermissionContext';
import AccessDenied from '../../../Agent/AccesDeined/AccessDenied';
import Profile from '../../../Agent/Profile';


export default () => {
  // const [type, setType] = useState();
  const { type, statusCode } = useContext(AuthContext);
  
  
  const { permissionsAccess } = useContext(PermissionContext);
 
//  console.log(statusCode);

  return (
    <div>
      <Layout />
      <ContainerWrap>
        <Route exact path="/app_dashboard" component={Dashboard} />
        <Route
          path="/agent/meal"
          render={() => (statusCode === '1' && permissionsAccess?.[0]?.master_id === '1'
            && permissionsAccess?.[0]?.view === 1 ? (
              <Meal />
            ) : (
              <AccessDenied />
            ))}
        />
        <Route 
          path="/agent/Profile"
          render={() => (statusCode === '1' ? (
            <Profile />
            ) : (
              <AccessDenied />
            ))}
        />
        <Route
          path="/agent/booking"
          render={() => (statusCode === '1' && permissionsAccess?.[1]?.master_id === '2'
            && permissionsAccess?.[1]?.view === 1 ? (
              <Booking />
            ) : (
              <AccessDenied />
            ))}
        />
        <Route
          path="/agent/account"
          render={() => (statusCode === '1' && permissionsAccess?.[2]?.master_id === '3'
            && permissionsAccess?.[2]?.view === 1 ? (
              <Account />
            ) : (
              <AccessDenied />
            ))}
        />
        <Route
          path="/agent/trip"
          render={() => (statusCode === '1' && permissionsAccess?.[3]?.master_id === '4'
            && permissionsAccess?.[3]?.view === 1 ? (
              <Trip />
            ) : (
              <AccessDenied />
            ))}
        />
    

        <Route
          path="/agent/payment/pending"
          render={() => (statusCode === '1' && permissionsAccess?.[2]?.master_id === '3'
            && permissionsAccess?.[2]?.approval === 1 ? (
              <PendingTable />
            ) : (
              <AccessDenied />
            ))}
        />
        <Route
          path="/agent/payment/approved"
          render={() => (statusCode === '1' && permissionsAccess?.[2]?.master_id === '3'
            && permissionsAccess?.[2]?.approval === 1 ? (
              <ApprovedTable />
            ) : (
              <AccessDenied />
            ))}
        />
        <Route
          path="/agent/payment/reject"
          render={() => (statusCode === '1' && permissionsAccess?.[2]?.master_id === '3'
            && permissionsAccess?.[2]?.approval === 1 ? (
              <RejectTable />
            ) : (
              <AccessDenied />
            ))}
        />
        <Route
          path="/usermanager/users"
          render={() => (statusCode === '1' && type === '0' ? (
            <Users />
            ) : (
              <AccessDenied />
            ))}
        />

        <Route
          path="/usermanager/manager"
          render={() => (statusCode === '1' && type === '0' ? (
            <Manager />
            ) : (
              <AccessDenied />
            ))}
        />


      </ContainerWrap>
    </div>
  );
}; 

// region STYLES

const ContainerWrap = styled.div`
  padding-top: 90px;
  min-height: 100vh;
  transition: padding-left 0.3s;

  ${paddingLeft}: 0;

  background: ${colorBackgroundBody};

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 150px;
  }
`;

// endregion
